/**
 * 右键菜单动画
 */
import fvAnimation from "./fvAnimation"
export default class fvContextMenu extends fvAnimation {
    constructor(shape){
        super(shape,"fvContextMenu");
        this.item = this.shape.animation.fvContextMenu.item;
        this.align = this.shape.animation.fvContextMenu.align;
    }

    run(event){
        this.action(event)
    }
    action(event){
        var style = {
            position:'absolute',
            zIndex:2000,
            left:event.clientX+'px',
            top:event.clientY-18+'px',
        }
        if(this.getEventType(event.type) == "down"){
            if(this.shape.animation.fvContextMenu){
                var menuList = [];
                var windowName = [];
                this.shape.fvScript.system.$.jsonSysRootConfig.contextMenu.forEach(function(element) {
                    if(element.title == this.item){
                        element.item.forEach((e)=>{
                            menuList.push({menuItem:e.itemName});
                            windowName.push({windowName:e.windowName,action:e.action,condition:e.condition})
                        })
                    }
                }, this);
                this.shape.fvScript.system.contextMenu.$.isContextmenu = true;
                this.shape.fvScript.system.contextMenu.$.show(event,1,style,menuList,this.align,windowName);
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/div/animationDiv/fvContextMenu.js